import { sumObjectArrayProperty } from '../utils/sumObjectArrayProperty'
import { formatDollars } from '../formatDollars'
import { getCountableMSServicesCount } from './MSServices'
import { doesQualifyToBeHidden } from './ItemAvailabilityStatus'
import type {
  IOpportunity,
  IOpportunityMasterService,
} from '~/types/opportunity/models'

const mn = '[cynqueModules/dataObjects/OpportunityMasterService.ts]'

export function OpportunityMasterService(oms: IOpportunityMasterService) {
  const fn = `${mn} OpportunityMasterService |`
  console.debug(`${fn} Called`)
  _initializeEmptyOpportunityMSServicesArray(oms)
  _calculateUnstoredOMSValues(fn, oms)
  _setOriginExistingCMSDescr(fn, oms)
  _setEstimatedMrcAmountEstimated1xAmountDescr(fn, oms)
  return oms
}

// Helper functions

function _initializeEmptyOpportunityMSServicesArray(
  oms: IOpportunityMasterService
) {
  if (!oms.opportunityMSServices) {
    oms.opportunityMSServices = []
  }
  if (!oms.opportunityMSTeamMembers) {
    oms.opportunityMSTeamMembers = []
  }
}

function _calculateUnstoredOMSValues(
  fn: string,
  oms: IOpportunityMasterService
) {
  oms.numLocations = new Set(
    oms.opportunityMSServices
      .filter((omss) => omss.doInclude && !doesQualifyToBeHidden(omss))
      .map((omss) => omss.location.id)
  ).size
  console.debug(`${fn} numLocations set to ${oms.numLocations} for ${oms.id}`)
  oms.numServices = getCountableMSServicesCount(oms.opportunityMSServices)
  console.debug(`${fn} numServices set to ${oms.numServices} for ${oms.id}`)
}

function _setOriginExistingCMSDescr(
  fn: string,
  oms: IOpportunityMasterService
) {
  oms.originExistingCMSDescr = oms.companyMasterService
    ? `${oms.origin.label}\n${oms.companyMasterService.label} (${oms.companyMasterService.hrid})`
    : oms.origin.label
}

function _setEstimatedMrcAmountEstimated1xAmountDescr(
  fn: string,
  oms: IOpportunityMasterService
) {
  const estimatedMrcAmountFormatted = formatDollars(oms.estimatedMrcAmount)
  const estimated1xamountFormatted = formatDollars(oms.estimatedOneTimeAmount)
  oms.estimatedMrcAmountEstimated1xAmountDescr = `${estimatedMrcAmountFormatted}\n${estimated1xamountFormatted}`
  console.debug(
    `${fn} estimatedMrcAmountEstimated1xAmountDescr set to ${oms.estimatedMrcAmountEstimated1xAmountDescr} for ${oms.id}`
  )
}

// Propagators

export function propagateOpportunityMSDataToOpportunity({
  callingFn,
  opportunity,
  masterServices,
  setUpOpportunity,
}: {
  callingFn: string
  opportunity: IOpportunity
  masterServices: IOpportunityMasterService[]
  setUpOpportunity: Function
}) {
  const fn = `${callingFn} ---> ${mn} propagateOpportunityMSDataToOpportunity |`
  opportunity.estimatedMrcAmount = sumObjectArrayProperty(
    fn,
    masterServices,
    'estimatedMrcAmount'
  )
  opportunity.estimatedOneTimeAmount = sumObjectArrayProperty(
    fn,
    masterServices,
    'estimatedOneTimeAmount'
  )
  opportunity.numMasterServices = masterServices.length ?? 0
  setUpOpportunity(opportunity)
}
